"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFieldWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormGroup = _interopRequireDefault(require("react-bootstrap/lib/FormGroup"));
var _ControlLabel = _interopRequireDefault(require("react-bootstrap/lib/ControlLabel"));
var _HelpBlock = _interopRequireDefault(require("react-bootstrap/lib/HelpBlock"));
var FormFieldWrapper = exports.FormFieldWrapper = function FormFieldWrapper(_ref) {
  var label = _ref.label,
    id = _ref.id,
    children = _ref.children,
    _ref$helpText = _ref.helpText,
    helpText = _ref$helpText === void 0 ? '' : _ref$helpText,
    _ref$valid = _ref.valid,
    valid = _ref$valid === void 0 ? false : _ref$valid,
    _ref$invalid = _ref.invalid,
    invalid = _ref$invalid === void 0 ? false : _ref$invalid,
    _ref$qaLabel = _ref.qaLabel,
    qaLabel = _ref$qaLabel === void 0 ? '' : _ref$qaLabel,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel;
  var validationState = valid && 'success' || invalid && 'error' || undefined;
  return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    controlId: id,
    validationState: validationState,
    "data-qa": qaLabel
  }, /*#__PURE__*/_react["default"].createElement(_ControlLabel["default"], {
    srOnly: !showLabel
  }, label), children, helpText && /*#__PURE__*/_react["default"].createElement(_HelpBlock["default"], null, helpText));
};

// is only needed to avoid snapshots updating
FormFieldWrapper.defaultProps = {
  showLabel: false,
  helpText: '',
  valid: false,
  invalid: false,
  qaLabel: ''
};